import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content-select-top-area" }
const _hoisted_3 = {
  key: 0,
  class: "select-tag"
}
const _hoisted_4 = { class: "select-tag-text" }
const _hoisted_5 = { class: "content-amount" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "sp-wrapper-right" }
const _hoisted_9 = { class: "content-item-title" }
const _hoisted_10 = { class: "tag-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "sp-wrapper-bottom" }
const _hoisted_16 = { class: "content-item-date" }
const _hoisted_17 = { class: "content-item-writer" }
const _hoisted_18 = { class: "writer-name" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "like-button" }
const _hoisted_21 = ["id", "checked", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "checked", "onChange"]
const _hoisted_24 = ["for"]

import { onMounted, ref, reactive, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { processing, processend } from "@/utils/view";
import { Content } from "@/models/contents/content";
import { Tag } from "@/models/contents/tag";
import { Disease } from "@/models/contents/disease";
import { Author } from "@/models/contents/author";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import ModalSearch from "@/components/modules/article/ModalSearch.vue";
import Pagination from "@/views/base/Pagination.vue";
import CommonMessage from "@/views/base/CommonMessage.vue";
import { _$t } from "@/utils/i18n";
// ---- Interfaces -------------------------------------------------
interface ArticleData {
  articleId: number;
  title: string;
  contentType: number;
  coverPhotoUrl: string;
  likeCount: number;
  dateFirstPublished: string;
  diseases: {
    diseaseCode: string;
    diseaseName: string;
  }[];
  tags: {
    tagId: number;
    tagName: string;
  }[];
  poster: {
    adminId: number;
    nickname: string;
  };
  isNew: boolean;
  isFavorite: boolean;
  isFollowed: boolean;
  isLiked: boolean;
}

interface TagResult {
  tagId: number;
  tagName: string;
  isAdded: boolean;
}

interface DiseaseResult {
  diseaseCode: string;
  diseaseName: string;
  isAdded: boolean;
}

interface PosterResult {
  adminId: number;
  nickname: string;
  isFollowed: boolean;
}

interface SearchCondition {
  tagIds: number[];
  diseaseCodes: string[];
  posterIds: number[];
}

// ---- Variable ----------------------------------------------

// --- Pagination設定 --------------------
const componentId = "generalpurpose06-04";
const activeMenu = "article";

export default /*@__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

let props = reactive({
  cond: {
    tagIds: [],
    diseaseCodes: [],
    posterIds: [],
  },
  page: 1, // 初期ページ
  size: 12, // 初期表示件数
  getTotalCount: (cond: any): Promise<number> => {
    const content = new Content();
    return content.searchArticlesCount(cond);
  },
  getPageData: (page: number, size: number, cond: any): Promise<any> => {
    const content = new Content();
    return content.searchArticles(page, size, cond);
  },
  refresh: 0, // リフレッシュトリガー
});

let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend();
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.href = "/cms/login";
    }
  },
});

// ---- Constants ----------------------------------------------
const router = useRouter();
const route = useRoute();
const articles = ref<ArticleData[]>([]);
const tags = ref<TagResult[]>([]);
const diseases = ref<DiseaseResult[]>([]);
const posters = ref<PosterResult[]>([]);
const content = new Content();
const tag = new Tag();
const disease = new Disease();
const author = new Author();
const totalCount = ref<number>(0);
const sessionErr = ref<boolean>(false);
const searchModalOpen = ref(false);
const initialized = ref<boolean>(false);
const expandedItems = reactive<{ [key: string]: boolean }>({});
const tagListRefs = reactive({});

// 「「○○」の記事」テキストの表示制御
const showSelectTagText = computed(() => {
  const { tagIds, diseaseCodes, posterIds } = props.cond;
  return (
    tagIds?.length > 0 || diseaseCodes?.length > 0 || posterIds?.length > 0
  );
});

// 疾患が1件だけ、かつ、タグも提供者も存在しないかどうか
const showInterestButton = computed(() => {
  const { tagIds, diseaseCodes, posterIds } = props.cond;
  return (
    tagIds?.length === 1 &&
    diseaseCodes?.length === 0 &&
    posterIds?.length === 0
  );
});

// 提供者が1件だけ、かつ、疾患もタグも存在しないかどうか
const showFollowButton = computed(() => {
  const { tagIds, diseaseCodes, posterIds } = props.cond;
  return (
    tagIds?.length === 0 &&
    diseaseCodes?.length === 0 &&
    posterIds?.length === 1
  );
});

// タグが1件だけ、かつ、関心のあるものに追加済みかどうか
const isInterestAdded = computed(() => {
  if (props.cond.tagIds?.length === 1) {
    return tags.value[0]?.isAdded ?? false;
  }
  return false;
});

// 提供者が1件だけ、かつ、フォロー中かどうか
const isFollowed = computed(() => {
  if (props.cond.posterIds?.length === 1) {
    return posters.value[0]?.isFollowed ?? false;
  }
  return false;
});

// ----- Functions -----------------------------------------------
// check height
const checkTagListHeight = (articleId: string | number): boolean => {
  const tagList = tagListRefs[articleId];
  if (tagList) {
    // total height ul (diseases and tags)
    const totalHeight = tagList.scrollHeight;
    return totalHeight > 135;
  }
  return false;
};

const toggleExpand = (articleId: string | number) => {
  if (expandedItems[articleId]) {
    expandedItems[articleId] = false;
  } else {
    expandedItems[articleId] = true;
  }
};

const notify = (result: any) => {
  // 初期化
  articles.value = [];
  if (!result.isSuccess) {
    const decodedMessage = decodeURIComponent(
      result.data.error?.response?.data?.message
    );
    const status = result.data.error?.response?.status;
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialog.open(decodedMessage);
    return;
  } else {
    // 件数がある場合は更新
    if (result.count !== undefined) {
      totalCount.value = result.count;
    }

    // データがある場合は更新
    if (result.data) {
      articles.value = result.data;
    }

    window.scrollTo({ top: 0 });
  }
};

// クエリパラメータから各データを初期化
const initializeFromQuery = async () => {
  try {
    initialized.value = false;

    const query = route.query;

    // 検索条件を設定する前に件数を0にリセット
    totalCount.value = 0;

    // 以前のデータを初期化
    tags.value = [];
    diseases.value = [];
    posters.value = [];

    if (query.cond) {
      const decodedCond = decodeURIComponent(query.cond as string);
      const parsedCond = JSON.parse(decodedCond);

      // 既存のprops.condの値を保持しながら、新しい値をマージ
      props.cond = {
        ...props.cond,
        tagIds: parsedCond.tagIds || [],
        diseaseCodes: parsedCond.diseaseCodes || [],
        posterIds: parsedCond.posterIds || [],
      };

      // 条件に基づいてデータを取得
      if (props.cond.tagIds?.length > 0) {
        await fetchTags();
      }
      if (props.cond.diseaseCodes?.length > 0) {
        await fetchDiseases();
      }
      if (props.cond.posterIds?.length > 0) {
        await fetchAuthors();
      }
    } else {
      // クエリパラメータがない場合は検索条件をリセット
      props.cond = {
        ...props.cond,
        tagIds: [],
        diseaseCodes: [],
        posterIds: [],
      };
    }
  } catch (error) {
    // エラー発生時の処理
    errorDialog.open(_$t("content_error_initialize_failed"));
  } finally {
    initialized.value = true;
  }
};

// タグ取得
const fetchTags = async () => {
  const [model, _response, err] = await tag.getTags(props.cond);
  if (!err) {
    tags.value = model.attributes?.result || [];
  } else {
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// 疾患取得
const fetchDiseases = async () => {
  const [model, _response, err] = await disease.getDiseases(props.cond);
  if (!err) {
    diseases.value = model.attributes?.result || [];
  } else {
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// 提供者取得
const fetchAuthors = async () => {
  const [model, _response, err] = await author.getAuthors(props.cond);
  if (!err) {
    posters.value = model.attributes?.result || [];
  } else {
    // セッションエラー
    const status = err.error?.response?.status;
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// タグ登録更新
const updateUserTags = async (tagId: number) => {
  await tag.updateUserTags(tagId).then(([model, _response, err]) => {
    if (err) {
      errorDialog.open(_$t("content_error_interest_update"));
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408 || status === 403) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    } else {
      const result = model.attributes?.result;
      tags.value[0].isAdded = result;
    }
  });
};

// 提供者フォロー更新
const updateUserAuthorFollows = async (posterId: number) => {
  await author
    .updateUserAuthorFollows(posterId)
    .then(([model, _response, err]) => {
      if (err) {
        errorDialog.open(_$t("content_error_author_follow_update"));
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        posters.value[0].isFollowed = result;
      }
    });
};

// 記事お気に入り更新
const updateUserArticleFavorites = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await content
    .updateUserArticleFavorites(articleId)
    .then(([model, _response, err]) => {
      if (err) {
        target.checked = !target.checked;
        errorDialog.open(_$t("content_error_article_favorite_update"));
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408 || status === 403) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;
        target.checked = result;

        const article = articles.value.find((a) => a.articleId === articleId);
        if (article) {
          article.isFavorite = result;
        }
      }
    });
};

// 記事いいね更新
const updateUserArticleLikes = async (articleId: number, event: Event) => {
  const target = event.target as HTMLInputElement;

  await content
    .updateUserArticleLikes(articleId, !target.checked)
    .then(([model, _response, err]) => {
      if (err) {
        // セッションエラー
        const status = err.error?.response?.status;
        if (status === 408) {
          const decodedMessage = decodeURIComponent(
            err.error?.response?.data?.message
          );
          sessionErr.value = true;
          errorDialog.open(decodedMessage);
        }
        return;
      } else {
        const result = model.attributes?.result;

        const article = articles.value.find((a) => a.articleId === articleId);
        if (article) {
          article.likeCount = result;
          article.isLiked = !article.isLiked;
        }
      }
    });
};

// 検索条件を指定して記事一覧ページに遷移
const goToArticlePageByCond = (cond: SearchCondition) => {
  // 新しい条件を設定する際に、前の条件を完全に上書き
  const newCond: SearchCondition = {
    tagIds: [],
    diseaseCodes: [],
    posterIds: [],
  };

  if (cond.tagIds?.length > 0) {
    newCond.tagIds = cond.tagIds;
  }

  if (cond.diseaseCodes?.length > 0) {
    newCond.diseaseCodes = cond.diseaseCodes;
  }

  if (cond.posterIds?.length > 0) {
    newCond.posterIds = cond.posterIds;
  }

  router.push({
    name: "article/search",
    query: { cond: encodeURIComponent(JSON.stringify(newCond)) },
  });
};

// 記事詳細ページへ遷移
const goToArticleDetailPage = (articleId: number) => {
  if (!articleId) return;

  router.push({
    name: "article/detail",
    params: { articleId },
  });
};

// タイトルを38文字以内に…で切り捨てる
const truncateTitle = (title: string): string => {
  if (!title) return "";

  if (title.length > 38) {
    return title.slice(0, 37) + "…";
  }

  return title;
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  await initializeFromQuery();
});

// クエリパラメータの変更を監視
watch(
  () => route.query,
  async () => {
    // クエリパラメータの有無に関わらず、常に初期化処理を実行
    await initializeFromQuery();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { "active-menu": activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "content-back-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("img", { src: "/server/necs/images/arrow-right_icon.png" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_msg_goBack")), 1)
            ]),
            (showSelectTagText.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diseases.value, (disease) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: disease.diseaseCode
                      }, [
                        _cache[8] || (_cache[8] = _createTextVNode(" 「")),
                        _createElementVNode("span", null, _toDisplayString(disease.diseaseName), 1),
                        _cache[9] || (_cache[9] = _createTextVNode("」 "))
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: tag.tagId
                      }, [
                        _cache[10] || (_cache[10] = _createTextVNode(" 「")),
                        _createElementVNode("span", null, _toDisplayString(tag.tagName), 1),
                        _cache[11] || (_cache[11] = _createTextVNode("」 "))
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posters.value, (poster) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: poster.adminId
                      }, [
                        _cache[12] || (_cache[12] = _createTextVNode(" 「")),
                        _createElementVNode("span", null, _toDisplayString(poster.nickname), 1),
                        _cache[13] || (_cache[13] = _createTextVNode("」 "))
                      ], 64))
                    }), 128)),
                    _createTextVNode(" " + _toDisplayString(posters.value.length > 0
                  ? _ctx.$t("contentsearch_msg_articleFrom_poster")
                  : _ctx.$t("contentsearch_msg_articleFrom")), 1)
                  ]),
                  (showInterestButton.value && !isInterestAdded.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "select-tag-add",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateUserTags(tags.value[0].tagId)))
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("img", { src: "/server/necs/images/article_add_icon_40.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentsearch_msg_addRelatedItems")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (showInterestButton.value && isInterestAdded.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "select-tag-added",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (updateUserTags(tags.value[0].tagId)))
                      }, [
                        _cache[15] || (_cache[15] = _createElementVNode("img", { src: "/server/necs/images/following.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentsearch_msg_addedRelatedItems")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (showFollowButton.value && !isFollowed.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "select-tag-follow",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (updateUserAuthorFollows(posters.value[0].adminId)))
                      }, [
                        _cache[16] || (_cache[16] = _createElementVNode("img", { src: "/server/necs/images/article_add_icon_40.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_follow")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (showFollowButton.value && isFollowed.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "select-tag-following",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (updateUserAuthorFollows(posters.value[0].adminId)))
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("img", { src: "/server/necs/images/following.png" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentdetail_button_following")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, _toDisplayString(totalCount.value) + _toDisplayString(_ctx.$t("contentdetail_msg_count")), 1)
          ]),
          _createElementVNode("ul", {
            class: _normalizeClass(["narrow-contents", { hide: articles.value.length === 0 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article, i) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "narrow-contents-items",
                key: article.articleId
              }, [
                _createElementVNode("div", {
                  class: "sp-wrapper",
                  onClick: ($event: any) => (goToArticleDetailPage(article.articleId))
                }, [
                  _createElementVNode("img", {
                    class: "content-item-img",
                    src: article.coverPhotoUrl,
                    alt: article.title
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-item-new", { none: !article.isNew }])
                    }, _toDisplayString(article.isNew ? _ctx.$t("home_msg_newContent") : ""), 3),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(truncateTitle(article.title)), 1)
                  ])
                ], 8, _hoisted_6),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", {
                    class: _normalizeClass(["content-item-tags", { heightExpanded: expandedItems[article.articleId] }]),
                    ref_for: true,
                    ref: (el) => (tagListRefs[article.articleId] = el)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.diseases, (disease, j) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "tag-item tag-disease",
                        key: j,
                        onClick: ($event: any) => (
                    goToArticlePageByCond({
                      diseaseCodes: [disease.diseaseCode],
                      tagIds: [],
                      posterIds: [],
                    })
                  )
                      }, _toDisplayString(disease.diseaseName), 9, _hoisted_11))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, j) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "tag-item tag-interest",
                        key: j,
                        onClick: ($event: any) => (
                    goToArticlePageByCond({
                      tagIds: [tag.tagId],
                      diseaseCodes: [],
                      posterIds: [],
                    })
                  )
                      }, _toDisplayString(tag.tagName), 9, _hoisted_12))
                    }), 128))
                  ], 2),
                  (checkTagListHeight(article.articleId))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!expandedItems[article.articleId])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "contents-height-all",
                              onClick: ($event: any) => (toggleExpand(article.articleId))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_show")), 1),
                              _cache[18] || (_cache[18] = _createElementVNode("img", {
                                src: "/server/necs/images/arrow-right_icon.png",
                                alt: "Show more"
                              }, null, -1))
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true),
                        (expandedItems[article.articleId])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "contents-height-hide",
                              onClick: ($event: any) => (toggleExpand(article.articleId))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_tab_recommend_search_hidden")), 1),
                              _cache[19] || (_cache[19] = _createElementVNode("img", {
                                src: "/server/necs/images/arrow-right_icon.png",
                                alt: "Show less"
                              }, null, -1))
                            ], 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(article.dateFirstPublished), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.$t("home_msg_author")), 1),
                      _createElementVNode("span", {
                        class: "writer-name-area",
                        onClick: ($event: any) => (
                      goToArticlePageByCond({
                        posterIds: [article.poster.adminId],
                        tagIds: [],
                        diseaseCodes: [],
                      })
                    )
                      }, _toDisplayString(article.poster.nickname), 9, _hoisted_19)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "writer-like",
                        id: `like-toggle${i}`,
                        checked: article.isLiked,
                        onChange: 
                      (e) => updateUserArticleLikes(article.articleId, e)
                    
                      }, null, 40, _hoisted_21),
                      _createElementVNode("label", {
                        for: `like-toggle${i}`,
                        class: "like-icon"
                      }, null, 8, _hoisted_22),
                      _withDirectives(_createElementVNode("p", null, "いいね", 512), [
                        [_vShow, article.likeCount === 0]
                      ]),
                      _withDirectives(_createElementVNode("p", null, _toDisplayString(article.likeCount), 513), [
                        [_vShow, article.likeCount > 0]
                      ])
                    ]),
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "writer-follow",
                      id: `follow-toggle${i}`,
                      checked: article.isFavorite,
                      onChange: 
                    (e) => updateUserArticleFavorites(article?.articleId, e)
                  
                    }, null, 40, _hoisted_23),
                    _createElementVNode("label", {
                      for: `follow-toggle${i}`,
                      class: "follow-icon"
                    }, null, 8, _hoisted_24)
                  ])
                ])
              ]))
            }), 128))
          ], 2),
          (initialized.value)
            ? (_openBlock(), _createBlock(Pagination, _mergeProps({ key: 0 }, _unref(props), { onNotify: notify }), null, 16))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "contents-list-button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (searchModalOpen.value = true))
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("img", { src: "/server/necs/images/article_search_button_icon.svg" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t("article_search_all")) + " ", 1),
            _cache[21] || (_cache[21] = _createElementVNode("span", null, null, -1))
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (searchModalOpen.value)
      ? (_openBlock(), _createBlock(ModalSearch, {
          key: 0,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (searchModalOpen.value = false))
        }))
      : _createCommentVNode("", true),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 1 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})